export const formStyles = {
    formTitleWrap: "mx-auto lg:w-[750px] max-w-full text-center ",
    formTitle: "lg:text-[40px] lg:leading-[49px] text-[30px] leading-[37px]  pb-11 text-white font-ProxNarrow formHead",
    formDesc:
        "mx-auto lg:w-[750px] max-w-full text-center lg:text-[25px] text-[23px] text-white mb-30 leading-30 formHead tracking-[0]",
    btnStyle:
        "bg-white border-solid border cursor-pointer block text-[23px] leading-[23px] my-0 mx-auto py-18 px-20 text-center w-[360px] h-[61px] max-w-[90%] border-darkBlue  transition-all rounded-[30px] my-15 hover:border-white hover:border-solid hover:border hover:border hover:text-white hover:bg-primary",
}
